'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentEloAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.6791 21.7581C18.4644 21.5006 19.3044 21.3608 20.1785 21.3608C23.993 21.3608 27.1749 24.0189 27.9049 27.55L33.3103 26.4688C32.07 20.4675 26.6626 15.95 20.1785 15.95C18.6939 15.95 17.265 16.1873 15.931 16.6243L17.6791 21.7581Z",
          fill: "#FFF200"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.2462 39.15L14.4828 34.9709C13.038 33.5096 12.1262 31.3763 12.1262 28.9983C12.1262 26.6221 13.0372 24.4887 14.4815 23.0285L11.2432 18.85C8.78836 21.3326 7.24138 24.9592 7.24138 28.9983C7.24138 33.0395 8.79063 36.6673 11.2462 39.15Z",
          fill: "#00A4E0"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.9065 30.45C27.1741 33.9805 23.9942 36.6353 20.183 36.6353C19.3086 36.6353 18.4669 36.4951 17.6816 36.2368L15.931 41.3733C17.267 41.8125 18.6964 42.05 20.183 42.05C26.6612 42.05 32.0651 37.5356 33.3103 31.5366L27.9065 30.45Z",
          fill: "#EF4123"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M59.3178 18.85V33.7016L61.9829 34.7699L60.7221 37.6991L58.0865 36.6397C57.4939 36.3912 57.0928 36.0126 56.7881 35.585C56.4955 35.1474 56.2786 34.5494 56.2786 33.7425V18.85H59.3178ZM39.1044 29.8881C39.1706 25.641 42.7875 22.2508 47.1764 22.3158C50.9014 22.3723 53.9878 24.8953 54.7985 28.251L40.3913 34.2054C39.5544 32.9682 39.0788 31.4799 39.1044 29.8881ZM42.4009 30.4836C42.3812 30.3054 42.3672 30.1227 42.3725 29.9383C42.4138 27.436 44.5432 25.4394 47.1289 25.4808C48.5364 25.499 49.7862 26.1223 50.631 27.0869L42.4009 30.4836ZM50.3277 33.2409C49.4594 34.0576 48.2819 34.5553 46.9818 34.5374C46.0906 34.523 45.2649 34.265 44.5629 33.8351L42.8224 36.5168C44.0144 37.2453 45.4198 37.6764 46.935 37.6991C49.1405 37.7308 51.1508 36.893 52.6125 35.5097L50.3277 33.2409ZM70.41 25.4808C69.8908 25.4808 69.3919 25.5619 68.9257 25.7132L67.8887 22.7082C68.6802 22.4526 69.5279 22.3138 70.41 22.3138C74.2593 22.3138 77.4705 24.9579 78.2069 28.4703L74.9966 29.1031C74.564 27.036 72.6749 25.4808 70.41 25.4808ZM65.1392 35.769L67.3083 33.397C66.3395 32.5676 65.7295 31.3563 65.7295 30.0062C65.7295 28.6574 66.3395 27.4467 67.3074 26.6179L65.1367 24.2459C63.491 25.6552 62.4541 27.7146 62.4541 30.0062C62.4541 32.3007 63.4918 34.3592 65.1392 35.769ZM70.4098 34.5333C72.6727 34.5333 74.5615 32.9794 74.9966 30.9152L78.2059 31.5508C77.466 35.0594 74.2557 37.6999 70.4098 37.6999C69.527 37.6999 68.6783 37.5607 67.8846 37.3039L68.9241 34.2999C69.3911 34.4508 69.8903 34.5333 70.4098 34.5333Z",
          fill: "black"
        }
      )
    ]
  }
);
const VpPaymentEloAsset = forwardRef(PaymentEloAsset);

export { VpPaymentEloAsset as default };
